module.exports = __webpack_public_path__ + "static/media/mail.53bfb48c.svg";